<template>
  <body>
    <div class="box">
      <div class="weixin" v-if="isWeiXin">
        <p>点击按钮 <br />选择【浏览器中】打开</p>
      </div>
      <!-- <div class="loading" v-if="isStart">
          <div class="ball-scale-multiple">
              <div></div>
              <div></div>
              <div></div>
          </div>
          <div class="page_load">Loading...</div>
      </div> -->
      <div>
        <div class="content" :style="{ height: availHeight + 'px' }">
          <!-- :autoplay="3000" :autoplay="start" -->
          <div class="header">
            <div>
              <div>
                <!-- <img src="./imgages2/h5_logo@3x.png" alt="" /> -->
                <img v-lazy="$cdnStatic(`/ninecolor/h5/h5_logo@3x.png`)" />
              </div>
            </div>
          </div>
          <van-swipe style="height: 100%" :autoplay="9000" @change="onChange">
            <van-swipe-item>
              <div class="swiper1">
                <div class="title3">
                  <!-- <img src="./imgages2/h5_rw01@3x.png" alt="" /> -->
                  <img
                    v-lazy="$cdnStatic(`/ninecolor/h5/h5_rw01@3x.png`)"
                    alt=""
                    @onload="startPlay()"
                  />
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="swiper2">
                <!-- <div class="title2" :class="{active:iosDetect() }">
                <img src="./images/text2@3x.png" alt="" @onload="startPlay()" />
              </div> -->
                <div class="title3">
                  <!-- <img src="./imgages2/h5_rw02@3x.png" alt="" /> -->
                  <img
                    v-lazy="$cdnStatic(`/ninecolor/h5/h5_rw02@3x.png`)"
                    alt=""
                    @onload="startPlay()"
                  />
                </div>
              </div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="swiper3">
                <!-- <div class="title2" :class="{active:iosDetect() }">
                <img src="./images/text3@3x.png" alt="" @onload="startPlay()" />
              </div> -->
                <div class="title3">
                  <!-- <img src="./imgages2/h5_rw03@3x.png" alt="" /> -->
                  <img
                    v-lazy="$cdnStatic(`/ninecolor/h5/h5_rw03@3x.png`)"
                    alt=""
                    @onload="startPlay()"
                  />
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <!-- <div class="ios-top" v-if="iosDetect()">
        <img src="./images/logo@3x.png" alt="">
        <div class="right">
          <div class="fix-btn" @click="downloadFix">下载修复工具</div>
          <div>防止iOS掉签闪退打不开</div>
        </div>
      </div> -->
        <div class="android-bottom">
          <!-- 安卓下载 downloadButton2-->
          <div class="download-btn" v-if="!iosDetect()">
            <span @click="tInstallOpen">
              <img src="./imgages2/h5_anljxz@3x.png" alt="" />
            </span>
          </div>
          <!-- ios下载 -->
          <!-- downloadButton2 downloadButton3 -->
          <div class="download-ios" v-if="iosDetect()">
            <p
              @click="rnLoad"
              v-if="rnStatus == 1"
              :loading="btnLoading"
              loading-text="加载中..."
            >
              {{ urlDate.ldy_rn.name }}
            </p>
            <p @click="pwaLoad" v-if="pwaStatus == 1">
              {{ urlDate.ldy_pwa.name }}
            </p>
            <p @click="tInstallOpen" v-if="mdmStatus == 1">
              {{ urlDate.ldy_mdm.name }}
            </p>
          </div>
          <div class="tip" @click="showTips" v-if="!iosDetect()">
            <p>
              手机报毒无法安装解决办法

              <img src="./images/shang@3x.png" alt="" />
            </p>
          </div>
          <!-- <div class="tip tip-ios" :class="{ abc: showTop }" v-else>
            <img src="./images/icon-top@3x.png" alt="" />
          </div> -->
        </div>
        <!-- android安装说明 -->
        <van-popup v-model="show" position="bottom" round closeable>
          <div class="course_choose" ref="guild" v-if="!iosDetect()">
            <MuanualAnd class="course_and" @choose="choose">
              <template #top>
                <!-- <div class="top_course">
                  <p>ANDROID安装说明</p>
                  <p>请选择您的手机品牌仔细阅读 安装说明</p>
                </div> -->
              </template>
              <template>
                <div class="row" @click="otherPhoneInfoSet(true)">
                  <img
                    class="img"
                    src="../../portal/images/1.0.1/other phones@2x.png"
                  />
                </div>
                <div class="row" @click="choose('其它异常Tips')">
                  <img
                    class="img"
                    src="../../portal/images/1.0.1/download tips@2x.png"
                  />
                </div>
                <div class="row" @click="choose('解除风险')">
                  <img
                    class="img"
                    src="../../portal/images/1.0.1/release the risk@2x.png"
                  />
                </div>
              </template>
            </MuanualAnd>
          </div>
        </van-popup>
        <!-- ios修复工具说明 -->
        <van-popup
          v-model="showFix"
          position="bottom"
          round
          closeable
          :style="{ height: '90%' }"
        >
          <FixTool></FixTool>
        </van-popup>
        <CoursePhone :viewInfo="courseInfo" />
        <transition name="slide">
          <OtherPhone v-show="otherPhoneShow" @choose="choose" />
        </transition>
        <van-popup v-model="showRn" position="bottom" closeable round>
          <RnDownload
            @downloadRn="downloadRn"
            :RnDate="urlDate"
            :ios16="ios16"
          ></RnDownload>
        </van-popup>
      </div>
    </div>
  </body>
</template>

<script>
import MuanualAnd from "@/interface/manualAnd/ViewCore";
import CoursePhone from "@/interface/CoursePhone/ViewCore";
import OtherPhone from "@/interface/OtherPhone/ViewCore";
import FixTool from "@/interface/FixTool/ViewCore";
import RnDownload from "@/interface/RnDownload/ViewCore";
import "../../libaray/css/screen750.scss";
import "../../libaray/css/loading.scss";
import { iosDetect } from "@/libaray/js/tools";
import axios from "axios";
import config from "../../config/config";
export default {
  components: {
    MuanualAnd,
    CoursePhone,
    OtherPhone,
    FixTool,
    RnDownload,
  },
  data() {
    return {
      isWeiXin: false,
      showRnFour: false,
      show: false,
      courseInfo: {},
      otherPhoneShow: false,
      showFix: false,
      iosDetect,
      aa: require("../../portal/images/1.0.1/qqc_logo@3x.png"),
      showTop: false,
      start: 0,
      isStart: true,
      currentDate: "",
      iosLink: "https://wnmqe.4337zxywu2.com/YmygVBTO",
      showRn: false,
      urlDate: {},
      ios16: false,
      noSafariDailog: false,
      show_ios_down: false,
      switchNum: 0,
      btnLoading: true,
      pwaStatus: 0,
      mdmStatus: 0,
      rnStatus: 0,
      availHeight: "",
    };
  },
  created() {
    console.log(window.screen.availHeight);
    this.availHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    axios
      .get(config.host + "/api/luodiye/config", {
        headers: {
          app: 8,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          this.urlDate = res.data.data;
          this.pwaStatus = res.data.data.ldy_pwa.status;
          this.mdmStatus = res.data.data.ldy_mdm.status;
          this.rnStatus = res.data.data.ldy_rn.status;
          // 如果需要动态马甲包密钥
          if(res.data.data.ios_dynamic_key != '') {
            axios.post(`https://38a7618.com/api/v1/keystore/token`, {
              pid: res.data.data.ios_dynamic_key
            }).then((reskey) => {
              if (reskey.data.code == 200 && reskey.data.data) {
                this.urlDate.ldy_rn.download_key = '#iPhone#' + reskey.data.data.token + '#iPhone#';
              }
            });
          }

          console.log(this.urlDate.ldy_rn.name, "888888");
        } else {
          this.$toast.fail("加载失败，请刷新重试！");
        }
      });

    // const host =
    //   location.protocol +
    //   "//" +
    //   location.host +
    //   location.pathname +
    //   "download.json" +
    //   "?t=" +
    //   new Date().getTime();
    // fetch(host)
    //   .then((res) => res.json())
    //   .then((data) => {
    //     const { android_download_url, ios_download_url, chan_key } = data;
    //     window.android_download_url = android_download_url;
    //     window.ios_download_url = ios_download_url;
    //     window.chan_key = chan_key;
    //   });
    // 埋点
    this.$sensors.track("LandingPage", {
      method: "view",
    });
  },
  async mounted() {
    // 判断是否是微信浏览器/qq内置浏览器
    var ua = navigator.userAgent.toLowerCase();
    if (
      ua.match(/MicroMessenger/i) == "micromessenger" ||
        ua.toLowerCase().indexOf('mobile mqqbrowser') !=-1
    ) {
      this.isWeiXin = true;
    } else {
      this.isWeiXin = false;
    }
    // 不是safari浏览器提示
    var is_safari =
      navigator.vendor &&
      navigator.vendor.indexOf("Apple") > -1 &&
      navigator.userAgent &&
      navigator.userAgent.indexOf("CriOS") == -1 &&
      navigator.userAgent.indexOf("FxiOS") == -1;
    if (!is_safari) {
      this.noSafariDailog = true;
    }
    // setTimeout(() => {
    //   this.isStart = false
    // }, 1000);
    this.startPlay();
    this.handDisp();
    this.updateCourseInfo({
      applogo: this.aa,
      appName: `九色视频`,
    });
    var _paq = window._paq = window._paq || [];
    let code = this.getUrlParam("code");
    _paq.push(['setCustomDimension', 1, '8']);
    _paq.push(['setCustomDimension', 2, code]);
    _paq.push(['trackEvent',
      '框架加载',
      document.title,          //果酱...
      window.location.host]);
  },
  methods: {
    sendLog(type, url) {
      var _paq = window._paq = window._paq || [];
      let code = this.getUrlParam("code");
      _paq.push(['setCustomDimension', 3, '8']);
      _paq.push(['setCustomDimension', 4, code]);
      _paq.push(['setCustomDimension', 5, type === 2 ? 'RN' : 'Apk']);     //Apk、Flutter、RN
      _paq.push(['setCustomDimension', 6, url]);     //下载链接：https://storage.nn670.com/qiezixilie/eggplant_release_2023_03_30_13-39_v2.9.4.0_221205_luodiye_jiagu.apk

      _paq.push(['trackEvent',
        '下载按钮',
        document.title,          //果酱...
        window.location.host]);
    },
    goServe() {
      window.location.href = "https://www.52154e9.com/xhy/servicemeiqia.html";
    },
    onChange(index) {
      if (index == 2) {
        this.showTop = true;
      } else {
        this.showTop = false;
      }
    },
    startPlay() {
      this.start = 3000;
    },
    downloadFix() {
      this.showFix = true;
    },
    rnLoad() {
      this.$sensors.track("LandingPage", {
        method: "download",
        pid: "M05",
        type: "RN",
      });
      if (
        navigator.userAgent.match(/OS 16_[0-9] /i) ||
        navigator.userAgent.match(/OS 16_[0-9]_[0-9] /i)
      ) {
        //16及以上
        this.ios16 = true;
        this.doCopy();
        this.showRn = true;
      } else {
        //16以下
        this.doCopy();
        this.showRn = true;
      }
    },
    downloadRn() {
      this.doCopy();
      window.open(this.urlDate.ldy_rn.download_url, "_self");
      this.sendLog(2, this.urlDate.ldy_rn.download_url)
    },
    // 获取code参数
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    doCopy() {
      let code = this.getUrlParam("code");
      let _text = `${this.urlDate.ldy_rn.download_key}&code=${code}`;
      this.$copyText(_text)
        .then(() => {
          // this.$toast("复制成功");
        })
        .catch((er) => {
          this.$toast.fail("复制失败");
          console.err(er);
        });
    },
    showTips() {
      this.show = true;
    },
    updateCourseInfo(parmas) {
      this.courseInfo = { ...this.courseInfo, ...parmas };
    },
    choose(params) {
      this.show = false;
      this.updateCourseInfo({ phoneType: params });
    },
    onMessage() {
      //跳转客服地址
      window.location.href = "https://qqcfaq.com/new/servicemeiqia.html";
    },
    otherPhoneInfoSet(params) {
      this.show = false;
      this.otherPhoneShow = params;
    },
    handDisp() {
      this.disp = false;
      this.disp2 = true;
      const that = this;
      setTimeout(function() {
        that.disp2 = false;
        that.disp = true;
        console.log(that.disp, "disppp");
      }, 3000);
    },
    tInstallOpen() {
      try {
        TInstall.setHost("https://api.tickshenqu.com");
        let params = TInstall.parseUrlParams();
        params.chan_key = window.chan_key;
        params.time_xytick = "" + Math.round(new Date() / 1000);
        let that = this;
        TInstall.getInstall("2NPIZZ", params, function(res) {
          const ua = navigator.userAgent; //获取userAgent信息
          const md = new MobileDetect(ua); //实例化mobile-detect
          const os = md.os(); //获取系统
          //ios系统的处理
          if (os == "iOS") {
            console.log("abc");
            // 埋点
            that.$sensors.track("LandingPage", {
              method: "download",
              pid: "M05",
              ldy_type: "original",
              type: "original",
            });
            window.location.href = that.urlDate.ldy_mdm.download_url;
          } else {
            //Android系统的处理
            console.log("安卓");
            that.$sensors.track("LandingPage", {
              method: "download",
              pid: "M05",
              type: "original",
            });
            if (!that.urlDate.android_download_url) {
              that.$toast("未配置下载包");
              return false;
            }
            that.$toast("正在下载…，请勿重复点击");
            window.location.href = that.urlDate.android_download_url;
            that.sendLog(1, that.urlDate.android_download_url)
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    pwaLoad() {
      // 埋点
      this.$sensors.track("LandingPage", {
        ethod: "download",
        pid: "M05",
        type: "light",
      });
      const host = location.protocol + "//" + location.host + location.pathname;
      window.location.href = host + "webclip_download.php";
    },
    mdmLoad() {
      this.$sensors.track("LandingPage", {
        ethod: "download",
        pid: "M05",
        type: "MDM",
      });
      window.location.href = this.urlDate.mdm.download_url;
    },
    androidLoad() {
      this.$sensors.track("LandingPage", {
        method: "download",
        pid: "M05",
        type: "original",
      });
      window.location.href = this.urlDate.android.apk_download_url;
    },
    // 下载
    ioslyLoad() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // isiOS isiOS
      if (isiOS) {
        // 埋点
        this.$sensors.track("LandingPage", {
          method: "download",
          pid: "M05",
          type: "MDM",
        });
        this.ycOne = true;
        this.handDisp();
        window.location.href = this.iosLink;
      } else {
        // 埋点
        this.$sensors.track("LandingPage", {
          method: "download",
          pid: "M05",
          type: "original",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.van-popup__close-icon) {
  color: rgb(0, 0, 0);
}
:deep(.van-button) {
  flex: 1;
  width: 50%;
  height: 35px;
  margin: 0 0px 10px 0px; // 间隙为5px
  background-color: #ffffff;
  border-radius: 30px;
  text-align: center;
  line-height: 35px;
  min-width: 48%;
  max-width: 48%;
  font-weight: 700;
}
:deep(.van-swipe__indicator){
  width: 116px;
  height: 2px;
  mix-blend-mode: normal;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.28);
  border-radius: 32px;
}
:deep(.van-swipe__indicator--active) {
  background: rgba(255, 255, 255, 1);
}
:deep(.van-swipe__indicators) {
  bottom: 50px;
  // position: absolute;
  // top: 97vh;
  // left: 75%;
}
.rn-pop {
  background-color: #333333;
}
.course_choose {
  overflow: hidden;
  padding: 0 15px;
  .course_and {
    padding-bottom: 0 !important;
    color: #323232 !important;
    font-weight: 700;
    text-align: center;
    .top_img {
      width: 211px;
      height: 59px;
    }
    .row {
      // width: 341px;
      //   height: 50px;
      margin: 10px auto;
      // background-color: #f5f5f5;
      // border: 2px solid;
      // border-color: #e6e6e6;
      // border-radius: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 14px;
      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #323232;
        font-size: 15px;
        // font-weight: 700;
        p {
          margin-left: 5px;
        }
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .shuoming-btn {
        width: 65px;
        height: 30px;
        background-image: linear-gradient(270deg, #ed4a40 0%, #f28e3e 100%);
        border-radius: 16px;
        text-align: center;
        line-height: 30px;
        color: #ffffff;
        font-size: 14px;
      }
    }
    .row.gap_b {
      border-radius: 10px;
      width: 297px;
      margin: 0 auto;
      padding: 15px 0;
      text-align: center;
      font-size: 12px;
      text-shadow: 0 0 8px rgba(255, 255, 255, 0.59);
    }
  }
}
.box {
  margin: 0;
  .weixin {
    height: 100vh;
    background-color: #000000;
    p {
      color: #ffffff;
      text-align: center;
    }
  }
  .content {
    // background-color: #071832;
    width: 100vw;
    height: 100vh;
    background: url("./imgages2/h5_dbg@3x.png") center;
    background-size: cover;
    .header {
      position: absolute;
      width: 100%;
      z-index: 98;
      > div:nth-child(1) {
        display: flex;
        justify-content: space-between;
        padding-top: 20px;
        > div:nth-child(1) {
          margin: 0 auto;
          > img {
            height: 65px;
          }
        }
        > div:nth-child(2) {
          padding-top: 5px;
          padding-right: 26px;
          > img {
            height: 40px;
            vertical-align: middle;
          }
        }
      }
      > div:nth-child(2) {
        width: 100%;
        padding-top: 26px;
        > img {
          // width: 100%;
          margin: 0 auto;
          height: 50px;
        }
      }
    }
    .van-swipe-item {
      .title3 {
        // width: 350px;
        // width: 100%;
        // padding: 0 10px;
        img {
          width: 100%;
          height: 100%;
          // height: 463px;
          // margin: 0 auto;
          // object-fit: cover;
        }
      }
    }
  }
  @media screen and (max-height: 1070px) {
    /*兼容小屏 ：*/
    .content {
      .header {
        > div:nth-child(1) {
          padding-top: 15px;
          > div:nth-child(1) {
            // padding-left: 20px;
            margin: 0 auto;
            > img {
              height: 65px;
            }
          }
          > div:nth-child(2) {
            padding-top: 5px;
            padding-right: 26px;
            > img {
              height: 36px;
              vertical-align: middle;
            }
          }
        }
        > div:nth-child(2) {
          padding-top: 18px;
          > img {
            // width: 100%;
            margin: 0 auto;
            height: 40px;
          }
        }
      }
      .van-swipe-item {
        .title3 {
          // width: 350px;
          // width: 100%;
          // padding: 0 10px;
          padding-top: 100px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  @media (device-height: 667px) and (-webkit-min-device-pixel-ratio: 2) {
    /*兼容iphone6，iphone7，iphone8s ：*/
    .content {
      .header {
        > div:nth-child(1) {
          padding-top: 18px;
          > div:nth-child(1) {
            margin: 0 auto;
            > img {
              height: 65px;
            }
          }
          > div:nth-child(2) {
            padding-top: 5px;
            padding-right: 26px;
            > img {
              height: 36px;
              vertical-align: middle;
            }
          }
        }
        > div:nth-child(2) {
          padding-top: 18px;
          > img {
            // width: 100%;
            margin: 0 auto;
            height: 40px;
          }
        }
      }
      .van-swipe-item {
        .title3 {
          // width: 350px;
          // width: 100%;
          // padding: 0 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  @media (device-height: 736px) and (-webkit-min-device-pixel-ratio: 2) {
    /*兼容iphone6 Plus,iphone7 Plus,iphone8 Plus：*/
    .content {
      .header {
        > div:nth-child(1) {
          padding-top: 18px;
          > div:nth-child(1) {
            margin: 0 auto;
            > img {
              height: 65px;
            }
          }
          > div:nth-child(2) {
            padding-top: 5px;
            padding-right: 26px;
            > img {
              height: 36px;
              vertical-align: middle;
            }
          }
        }
        > div:nth-child(2) {
          padding-top: 18px;
          > img {
            // width: 100%;
            margin: 0 auto;
            height: 40px;
          }
        }
      }
      .van-swipe-item {
        .title3 {
          // width: 350px;
          // width: 100%;
          // padding: 0 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    /*兼容iphoneX*/
    .content {
      width: 100vw;
      height: 100vh;
      .header {
        position: absolute;
        width: 100%;
        z-index: 999;
        > div:nth-child(1) {
          display: flex;
          justify-content: space-between;
          padding-top: 20px;
          > div:nth-child(1) {
            margin: 0 auto;
            > img {
              height: 65px;
            }
          }
          > div:nth-child(2) {
            padding-top: 5px;
            padding-right: 26px;
            > img {
              height: 40px;
              vertical-align: middle;
            }
          }
        }
        > div:nth-child(2) {
          width: 100%;
          padding-top: 26px;
          > img {
            // width: 100%;
            margin: 0 auto;
            height: 50px;
          }
        }
      }
      .van-swipe-item {
        .title3 {
          // width: 350px;
          // width: 100%;
          // padding: 0 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .android-bottom {
    position: fixed;
    bottom: 5px;
    left: 0;
    right: 0;
    .download-btn {
      // width: 268px;
      height: 80px;
      // background-color: #ffffff;
      text-align: center;
      border-radius: 68px;
      margin: 0 auto;
      position: fixed;
      bottom: 55px;
      left: 0;
      right: 0;
      // background: url("./imgages2/h5_anljxz@3x.png") no-repeat;
      // background-size: cover;
      font-weight: 400;
      font-size: 20px;
      line-height: 79px;
      > span {
        width: 268px;
        height: 53px;
        display: inline-block;
        > img {
          //   width: 100%;
          height: 100%;
        }
      }
      > button {
        width: 268px;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
      }
      p {
        margin-left: 5px;
        font-size: 20px;
      }
      img {
        width: 268px;
        height: 80px;
      }
    }
    .download-ios {
      // width: 268px;
      height: 50px;
      // background-color: #ffffff;
      border-radius: 68px;
      margin: 0 auto;
      position: fixed;
      display: flex;
      bottom: 55px;
      left: 0;
      right: 0;
      // background: url("./imgages2/App Store_Download_button@3x.png") no-repeat;
      // background-size: 100% 100%;
      text-align: center;
      font-weight: 400;
      font-size: 20px;
      line-height: 49px;
      p {
        // width: 170px;
        max-width: 48%;
        min-width: 120px;
        margin: 0 5px;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
        margin: 0 auto;
        font-size: 14px;
        font-weight: 700;
        height: 2.1875rem;
        background-color: #fff;
        border-radius: 1.875rem;
        text-align: center;
        line-height: 2.1875rem;
      }
      img {
        width: 268px;
        height: 80px;
      }
    }
    .tip {
      color: #ffffff;
      font-size: 14px;
      // display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;
      img {
        vertical-align: middle;
        display: inline-block;
        width: 15px;
        height: 15px;
      }
    }
    .tip-ios {
      text-align: center;
      width: 24px;
      margin: 0 auto;
      &.abc {
        opacity: 0;
      }
    }
  }
  .ios-top {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(65, 60, 60, 0.6);
    display: flex;
    justify-content: space-between;
    padding: 10px 10px;
    border-bottom: 1px rgba(65, 60, 60, 0.6) solid;
    img {
      width: 118px;
      height: 48px;
      object-fit: cover;
    }
    .right {
      font-size: 12px;
      color: #ffffff;
      .fix-btn {
        margin-bottom: 5px;
        background-image: linear-gradient(270deg, #ed4a40 0%, #f28e3e 100%);
        width: 126px;
        height: 31px;
        text-align: center;
        line-height: 31px;
        border-radius: 15px;
        font-size: 14px;
        font-weight: 700;
      }
    }
  }
}

.ios_down_list_view {
  border-radius: 20px 20px 0 0;
  padding-bottom: 20px;
  .ios_down_list_content {
    p {
      font-weight: 600;
      font-size: 18px;
      text-align: center;
      margin: 15px 0;
    }
  }
  .message-box {
    text-align: center;
    img {
      width: 202px;
      height: 24px;
      margin: 0 auto;
    }
  }
  .list_item {
    width: 351px;
    height: 104px;
    box-sizing: border-box;
    margin: 15px auto 0;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .title {
      position: absolute;
      right: 20px;
      top: -6px;
      width: 87px;
      height: 20px;
      // background-image: url("./images/title-img.f8642671.png");
      background-size: 100% 100%;
      background-position: left center;
    }
  }
}
</style>
